
import { defineComponent, onBeforeMount, PropType, reactive, toRaw } from 'vue'

// components
import Modal from '@/common/components/UI/Modal/index.vue'
import TheInput from '@/common/components/UI/TheInput/index.vue'

// types
import { CompanySetClientPayloadT } from '@/core/types/companies.types'

// validation
import useVuelidate from '@vuelidate/core'
import { required, email } from '@vuelidate/validators'

export default defineComponent({
    components: {
        modal: Modal,
        'the-input': TheInput,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        initialValue: {
            type: Object as PropType<CompanySetClientPayloadT>,
            default: null,
        },
    },
    emits: ['set', 'cancel'],
    setup(props, { emit }) {
        const state = reactive({
            id: null as number | null,
            //
            approvingEmail: null as string | null,
            signerEmail: null as string | null,
        })

        let state_form$ = useVuelidate(
            {
                approvingEmail: { email },
                signerEmail: { required, email },
            },
            state
        )

        const setInfo = () => {
            state.id = props.initialValue.id

            state.approvingEmail = props.initialValue.approvingEmail
            state.signerEmail = props.initialValue.signerEmail
        }

        const emitSet = () => {
            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            emit('set', toRaw(state))
        }

        const emitCancel = () => {
            emit('cancel')
        }

        onBeforeMount(() => {
            if (props.initialValue) setInfo()
        })

        return {
            state,
            //
            state_form$,
            //
            emitSet,
            emitCancel,
        }
    },
})
